module.exports = __webpack_public_path__ + "img/banner-landing-image.52b78bb6.png";